import React, { useEffect, useState } from "react";
import Header from "../../layout/header";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { BackArrowIcon } from "../../components/ui-elements/svg-icons";
import { apiGetAccount } from "../../api/account";
import { useQuery } from "@tanstack/react-query";
import {
  AccountProfileData,
  DummyAccountProfileData,
} from "../../interface/account";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useNotificationService } from "../../hooks/notification";
import { SelectOption } from "../../utils/adhoc-request";
import { useNavigate } from "react-router-dom";
import EditContent from "../../components/account/edit-content";
import useResponsive from "../../hooks/useResponsive";
import { SkeletonRepsAccountLoading } from "../../components/ui-elements/skeleton-loading";

const Edit = () => {
  const { showNotification } = useNotificationService();
  const theme = useTheme();
  const navigate = useNavigate();
  const [account_profile_data, setaccount_profile_data] =
    useState<AccountProfileData>(DummyAccountProfileData);
  const account = useSelector(
    (state: RootState) => state.content.account_profile_data
  );

  const isSmall = useResponsive("down", "sm", "xl");

  const { data: accountProfileDetails, isLoading } = useQuery({
    queryKey: ["account-profile-details", account?.id],
    queryFn: () => apiGetAccount(account?.id),
    enabled: Boolean(account.id),
    staleTime: 1000 * 60 * 10,
    select: (response) => {
      
      if (response?.status === "error") {
        if ("details" in response) {
          showNotification(response?.details ?? "An error occurred", "error");
          return DummyAccountProfileData;
        }
        return DummyAccountProfileData;
      }
      if (response?.status === 200) {
        return response?.data as AccountProfileData;
      }
      return DummyAccountProfileData;
    },
  });
  
  return (
    <>
      {/* Header Menu */}
      <Box
        sx={{
          background: theme.palette.background.paper,
        }}
      >
        <Header scrollContainerId="main-scroll-container">
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <Button onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </Button>
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              Edit Profile
            </Typography>
          </Stack>
        </Header>
        {isLoading && (
          <Box
            sx={{
              width: isSmall ? "90%" : 600,
              height: "90vh",
              pt: "6rem",
              mx: "auto",
            }}
          >
            <SkeletonRepsAccountLoading />
          </Box>
        )}
        {!isLoading && !!account_profile_data && (
          <EditContent account_profile_data={accountProfileDetails ?? DummyAccountProfileData} />
        )}
      </Box>
    </>
  );
};

export default Edit;
